import imageCompression from "browser-image-compression";

export const allowedImageMimeTypes = ["image/png", "image/jpg", "image/jpeg"];

// Function to compress files
// options.onProgress(index, progress) — progress from 0 to 100 per file
export const compressFiles = (files, intl, options = {}) => {
  const { onProgress } = options;
  const fileSize = 1 * 1024 * 1024; // 1 MB threshold for compression

  const reportProgress = (index, progress) => {
    onProgress?.(index, Math.min(100, Math.max(0, Math.round(progress))));
  };

  // Process each file asynchronously using Promise.all
  return Promise.all(
    Array.from(files).map(async (file, index) => {
      // Check if the file size is greater than or equal to the threshold
      if (file.size >= fileSize && allowedImageMimeTypes.includes(file.type)) {
        try {
          reportProgress(index, 0);
          const compressionOptions = {
            initialQuality: getCompressionQuality(file.size),
            alwaysKeepResolution: true,
            fileType: "image/jpeg",
            onProgress: (progress) => reportProgress(index, progress),
          };

          const compressedFile = await imageCompression(file, compressionOptions);
          reportProgress(index, 100);

          return new File([compressedFile], file.name, {
            type: compressedFile.type,
            lastModified: Date.now(),
          });
        } catch (error) {
          console.error(intl.formatMessage({ id: "compression-error" }), error);
          reportProgress(index, 100);
          return file;
        }
      }

      reportProgress(index, 100);
      return file;
    })
  );
};

export const getCompressionQuality = (imageSize) => {
  if (imageSize > 5000000) {
    // > 5MB
    return 0.3;
  } else if (imageSize > 2000000) {
    // 2MB - 5MB
    return 0.5;
  } else if (imageSize > 1000000) {
    // 1MB - 2MB
    return 0.7;
  } else {
    return 0.9;
  }
};
